import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    async setMain(event: Event): Promise<void> {
        const btn = event.currentTarget as HTMLElement;
        const url = btn.dataset.url ?? '';
        const pictureId = btn.dataset.pictureId ?? '';

        if (!confirm('¿Usar esta foto como imagen principal?')) {
            return;
        }

        const response = await fetch(url, { method: 'POST' });
        const data = await response.json() as { success: boolean; newMainImage?: string };

        if (data.success) {
            const preview = document.querySelector<HTMLImageElement>('[data-image-preview-target="preview"]');
            if (preview && data.newMainImage) {
                preview.src = data.newMainImage;
            }
            document.getElementById(`picture-card-${pictureId}`)?.remove();

            const grid = document.getElementById('photos-history-grid');
            if (grid && grid.querySelector('.col-md-4') === null) {
                grid.innerHTML = '<div class="col-12"><p class="text-muted">No hay fotos en el historial.</p></div>';
            }
        }
    }

    async deletePicture(event: Event): Promise<void> {
        const btn = event.currentTarget as HTMLElement;
        const url = btn.dataset.url ?? '';
        const pictureId = btn.dataset.pictureId ?? '';

        if (!confirm('¿Eliminar esta foto del historial? Esta acción no se puede deshacer.')) {
            return;
        }

        const response = await fetch(url, { method: 'DELETE' });
        const data = await response.json() as { success: boolean };

        if (data.success) {
            document.getElementById(`picture-card-${pictureId}`)?.remove();

            const grid = document.getElementById('photos-history-grid');
            if (grid && grid.querySelector('.col-md-4') === null) {
                grid.innerHTML = '<div class="col-12"><p class="text-muted">No hay fotos en el historial.</p></div>';
            }
        }
    }
}
